<template>
<div>
    <router-view/>
</div>
</template>

<script>
const resourceNames = [
    'Login',
    'Register',
    'Context',
    'Logout',
    'Forgot',
    'Reset',
    'Password',
    'Confirm',
    'Unsubscribe',
    'Plan',
    'PlanLowest',
    'Data',
    'Stats',
    'Token',
    'PromoCode',
    'APIKey',
    'Transaction',
    'Payment',
    'PaymentSystem',
    'Invoice',
    'Review',
    'ReviewAggregate',
    'Payout',
    'TgLogin',
    'TgComplete',
    'BlogPosts',
    'BlogPost',
]

const stateComputeds = {
    context() {
        return this.$state.context
    },
    siteProto() {
        return this.$state.siteProto
    },
    siteDomain() {
        return this.$state.siteDomain
    },
    siteName() {
        return this.$state.siteName
    },
    siteEmail() {
        return this.$state.siteEmail
    },
    siteTgSupport() {
        return this.$state.siteTgSupport
    },
    siteTgBase() {
        return this.$state.siteTgBase
    },
    cfSiteKey() {
        return this.$state.cfSiteKey
    },
    capiUrl() {
        return this.$state.capiUrl
    },
}

const resourceComputeds = Object.fromEntries(
    resourceNames.map(name => [name, function() {
        return this.$services[name]()
    }])
)

export default {
    computed: {
        ...stateComputeds,
        ...resourceComputeds,
        HealthCheck() {
            return this.$services.HealthCheck(this.siteProto, this.siteDomain)
        },
    },
    methods: {
        copyToClipboard(content) {
            return this.$methods.copyToClipboard(content)
        },
        raise404() {
            return this.$methods.raise404()
        },
        raise500() {
            return this.$methods.raise500()
        },
        getContext() {
            return this.$methods.getContext()
        },
        informContext() {
            return this.$methods.informContext()
        },
        updateContext(context) {
            return this.$methods.updateContext(context)
        },
        buildTitle(title) {
            return this.$methods.buildTitle(title)
        },
        updateSEOMeta(meta, path) {
            return this.$methods.updateSEOMeta(meta, path)
        },
    },
}
</script>
